module.exports = __webpack_public_path__ + "static/media/IMG_4239.ee8c098d.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/bonus/desnat/IMG_4239.JPG
// module id = 48
// module chunks = 0